import { USER_INFO, DATA_OXXO, DATA_SPEI } from '../types';

export default (state, action) => {
  switch (action.type) {
    case USER_INFO:
      return {
        ...state,
        user: action.payload,
      };

    case DATA_OXXO:
      return {
        ...state,
        dataOxxo: action.payload,
      };

    case DATA_SPEI:
      return {
        ...state,
        dataSpei: action.payload,
      };

    default:
      return state;
  }
};
